'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
require('../../../../buttons/ClearButton/ClearButton.js');
require('../../../../buttons/SecondaryButton/SecondaryButton.js');
require('../../../../buttons/AddAttachmentsButton/AddAttachmentsButton.js');
require('../../../../buttons/BlueTextButton/BlueTextButton.js');
require('../../../../buttons/BackButton/BackButton.js');
var Grid = _interopDefault(require('@material-ui/core/Grid'));
require('../../../../buttons/BorderlessButton/BorderlessButton.js');
require('../../../../buttons/ButtonAndStatus/ButtonAndStatus.js');
require('../../../../buttons/ButtonGroup/ButtonGroup.js');
require('../../../../buttons/DialogPrimaryButton/DialogPrimaryButton.js');
require('../../../../buttons/DialogSecondaryButton/DialogSecondaryButton.js');
require('../../../../buttons/DialogWarningButton/DialogWarningButton.js');
require('../../../../buttons/FormButton/FormButton.js');
require('../../../../buttons/IconButtonWithDropDown/IconButtonWithDropDown.js');
require('../../../../buttons/PillButton/PillButton.js');
var PrimaryButton = require('../../../../buttons/PrimaryButton/PrimaryButton.js');
require('../../../../buttons/TwoToneButton/TwoToneButton.js');
require('../../../../buttons/WarningButton/WarningButton.js');
require('../../../../buttons/AvatarButtons/ButtonWithAvatar/ButtonWithAvatar.js');
require('../../../../buttons/AvatarButtons/AvatarWithSubtitle/AvatarWithSubtitle.js');
require('../../../../buttons/AvatarButtons/VerticalAvatar/VerticalAvatar.js');
require('../../../../inputs/utils/highlight.js');
require('../../../../inputs/SelectWithLabel/SelectWithLabel.js');
require('../../../../inputs/ToggleSwitch/ToggleSwitch.js');
require('../../../../inputs/InputSelect/InputSelect.js');
require('../../../../inputs/TimeInputSelect/TimeInputSelect.js');
require('../../../../inputs/ActiveWeekdayHours/ActiveWeekdayHours.js');
var InputWithTopLabel = require('../../../../inputs/InputWithTopLabel/InputWithTopLabel.js');
require('../../../../inputs/SelectWithTopLabel/SelectWithTopLabel.js');
require('../../../../inputs/AddressInput/AddressInput.js');
require('../../../../inputs/AddressInputWithValidation/validators.js');
require('../../../../inputs/AddressInputWithValidation/AddressInputWithValidation.js');
require('../../../../inputs/AsyncMultiSelectControlled/AsyncMultiSelectControlled.js');
require('../../../../inputs/AsyncMultiSelectWithTopLabel/AsyncMultiSelectWithTopLabel.js');
require('../../../../inputs/AsyncSelectWithTopLabel/AsyncSelectWithTopLabel.js');
require('../../../../inputs/InputCheckbox/InputCheckbox.js');
require('../../../../inputs/InputTextarea/InputTextarea.js');
require('../../../../inputs/InputWithIcon/InputWithIcon.js');
require('../../../../inputs/InputWithLeftMenu/InputWithLeftMenu.js');
require('../../../../inputs/ListSelect/ListSelect.js');
require('../../../../inputs/MultiSelectMenu/MultiSelectMenu.js');
require('../../../../inputs/MultiSelectWithTopLabel/MultiSelectWithTopLabel.js');
require('../../../../inputs/NumberSelect/NumberSelect.js');
require('../../../../inputs/OutlinedInputWithIcon/OutlinedInputWithIcon.js');
require('../../../../inputs/OutlinedInputWithTopLabel/OutlinedInputWithTopLabel.js');
require('../../../../inputs/PhoneNumberInputWithTopLabel/PhoneNumberInputWithTopLabel.js');
require('../../../../inputs/RadioButtonGroup/RadioButtonGroup.js');
require('../../../../inputs/ConfirmationMultiSelectMenu/ConfirmationSelectMenu.js');
var styledComponents = require('./styled-components.js');

var InputWithSubmitButton = function (props) {
    var onChange = props.onChange, value = props.value, _a = props.error, error = _a === void 0 ? false : _a, title = props.title, onSubmit = props.onSubmit, _b = props.disabled, disabled = _b === void 0 ? false : _b;
    return (React__default.createElement(styledComponents.InputContainer, { container: true },
        React__default.createElement(styledComponents.InputGridItem, { item: true, xs: 11 },
            React__default.createElement(InputWithTopLabel, { reporter: onChange, value: value, error: error })),
        React__default.createElement(Grid, { item: true, xs: 1 },
            React__default.createElement(PrimaryButton, { title: title, onClick: onSubmit, disabled: disabled, "data-testid": 'inputWithSubmit-button' }))));
};

module.exports = InputWithSubmitButton;
